module.exports = __webpack_public_path__ + "77f4eddb484b8f32d38a5b970c10592b.svg";